import api from "./api";

/**
 * Add a property to the user's shortlist
 * @param {string} userId - ID of the user
 * @param {string} propertyId - ID of the property
 * @returns {Promise<Object>} Success message
 */
export const addToShortlist = async (userId, propertyId) => {
  try {
    const response = await api.post("/api/shortlist/add", { userId, propertyId });
    return response.data;
  } catch (error) {
    console.error("Error adding to shortlist:", error);
    throw error;
  }
};

/**
 * Remove a property from the user's shortlist
 * @param {string} userId - ID of the user
 * @param {string} propertyId - ID of the property
 * @returns {Promise<Object>} Success message
 */
export const removeFromShortlist = async (userId, propertyId) => {
  try {
    const response = await api.post("/api/shortlist/remove", { userId, propertyId });
    return response.data;
  } catch (error) {
    console.error("Error removing from shortlist:", error);
    throw error;
  }
};

/**
 * Get all shortlisted properties for a user
 * @param {string} userId - ID of the user
 * @returns {Promise<Array>} Array of shortlisted properties
 */
export const getUserShortlistedProperties = async (userId) => {
  try {
    const response = await api.get(`/api/shortlist/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching shortlisted properties:", error);
    throw error;
  }
};
